import { render, staticRenderFns } from "./AppCategories.vue?vue&type=template&id=21a293a4&"
import script from "./AppCategories.vue?vue&type=script&lang=js&"
export * from "./AppCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports